import { render } from "./Attend.vue?vue&type=template&id=3655af92&scoped=true"
import script from "./Attend.vue?vue&type=script&lang=js"
export * from "./Attend.vue?vue&type=script&lang=js"

import "./Attend.vue?vue&type=style&index=0&id=3655af92&lang=less&scoped=true"

import exportComponent from "D:\\workbuddy\\LaiShanKeHou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3655af92"]])

export default __exports__